export const clearStore = "ERROR_CLEAR_STORE";


export const listLoadStart = 'ERROR_LIST_LOAD_START';
export const listLoadSuccess = 'ERROR_LIST_LOAD_SUCCESS';
export const listLoadFail = 'ERROR_LIST_LOAD_FAIL';

export const itemDeleteStart = 'ERROR_DELETE_START';
export const itemDeleteSuccess = 'ERROR_DELETE_SUCCESS';
export const itemDeleteFail = 'ERROR_DELETE_FAIL';